import { StringTemplate } from '@oy/uidesktop';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import { resendVerificationEmail } from 'src/clients';
import { useTranslate } from 'src/hooks';
import styles from './LoginMessage.module.css';

export type TemplateData = Record<string, string | number | JSX.Element>;

export type LoginMessageTemplate = {
  key: string;
  data?: Record<string, string | number | null | undefined>;
};

export type LoginMessageData = {
  type: 'success' | 'error' | 'warning';
  message?: string;
  template?: LoginMessageTemplate;
};

type LoginMessageProps = {
  data: LoginMessageData | null;
};

export const LoginMessage = ({ data }: LoginMessageProps) => {
  const navigate = useNavigate();

  const { getTranslation } = useTranslate();

  if (!data) return null;

  const handleResendVerificationEmail = (username: string) => {
    if (!username) return;
    resendVerificationEmail({ username }).then(res => {
      const email = res.data.userEmail;
      navigate('/email-verification', { state: { username, email } });
    });
  };

  const buildMessageFromTemplate = (template: LoginMessageTemplate) => {
    const templateData: TemplateData = {};

    switch (template.key) {
      case 'login_statusMessage_notActivated':
        if (!template.data) break;
        const username = template.data.username as string;
        templateData.resend = (
          <span
            className={styles.resendEmailVerification}
            onClick={() => {
              handleResendVerificationEmail(username);
            }}
          >
            {getTranslation('common_resend_activation_email')}
          </span>
        );
        break;
      case 'login_statusMessage_inCoolDown':
      case 'otp_statusMessage_alreadyRequested':
        if (!template.data) break;
        const remainingTime = template.data.remainingTime as number;
        templateData.number = remainingTime;
        break;
      default:
        break;
    }

    return (
      <StringTemplate
        str={getTranslation(template.key)}
        template={templateData}
      />
    );
  };

  const buildMessage = () => {
    const { message, template } = data;
    if (message) return message;
    if (template) return buildMessageFromTemplate(template);
    return null;
  };

  return (
    <div className={classNames(styles.container, styles[data.type])}>
      {buildMessage()}
    </div>
  );
};
